import { ClassNameProps } from "@/types";

/**
 * Variants for the RatingsBadge component.
 */
enum RatingsBadgeVariant {
  Primary = "primary",
  Secondary = "secondary",
}

/**
 * Sizes for the RatingsBadge component.
 * Small is currently only used on mobile.
 */
enum RatingsBadgeSize {
  Medium = "medium",
  Small = "small",
}

interface RatingsBadgeProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  variant?: RatingsBadgeVariant;
  size?: RatingsBadgeSize;
}

export { RatingsBadgeVariant, RatingsBadgeSize };
export type { RatingsBadgeProps };
